import TagsInputBox from "./TagsInputBox";

export default TagsInputBox;